import React, { useState } from 'react';
import Header from '../../components/ui/Header';
import HeroSlider from './components/HeroSlider';
import CountryFilter from './components/CountryFilter';
import FeaturedBeansGrid from './components/FeaturedBeansGrid';
import CTASection from './components/CTASection';
import Icon from '../../components/AppIcon';
import { FullWidthSection, ContentWrapper } from '../../components/ui/Layout';
import { useLanguage } from '../../contexts/LanguageContext';

import SponsorBanner from './components/SponsorBanner';

const Home = () => {
  const { language } = useLanguage();
  const [selectedCountry, setSelectedCountry] = useState('all');
  const [selectedProcessing, setSelectedProcessing] = useState(null);
  const [elevationRange, setElevationRange] = useState({ min: '', max: '' });

  const handleCountryChange = (countryId) => {
    setSelectedCountry(countryId);
  };

  const handleProcessingChange = (processing) => {
    setSelectedProcessing(processing);
  };

  const handleElevationChange = (range) => {
    setElevationRange(range);
  };


  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-[60px]">
        {/* Hero Section - Full Width */}
        <FullWidthSection padding="" py="py-0" className="mb-8">
          <HeroSlider language={language} selectedCountry={selectedCountry} />
        </FullWidthSection>

        {/* Main Content Area - Full Width with Grid Layout */}
        <FullWidthSection padding="" py="py-8">
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="lg:grid lg:grid-cols-[280px_1fr] lg:gap-8">
              {/* Left Sidebar - Country Filter */}
              <div className="mb-8 lg:mb-0">
                <CountryFilter
                  language={language}
                  selectedCountry={selectedCountry}
                  onCountryChange={handleCountryChange}
                  onProcessingChange={handleProcessingChange}
                  onElevationChange={handleElevationChange}
                />
              </div>

              {/* Right Content Area */}
              <div className="space-y-8">
                <SponsorBanner language={language} />
                <FeaturedBeansGrid
                  language={language}
                  selectedCountry={selectedCountry}
                  selectedProcessing={selectedProcessing}
                  elevationRange={elevationRange}
                />
                <CTASection language={language} />
              </div>
            </div>
          </div>
        </FullWidthSection>

        <footer className="bg-card border-t border-border mt-16">
          <FullWidthSection padding="" py="py-8">
            <div className="px-4 sm:px-6 lg:px-8">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                <div>
                  <div className="flex items-center gap-2 mb-4">
                    <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                      <Icon name="Coffee" size={24} color="var(--color-primary)" />
                    </div>
                    <span className="text-xl font-heading font-semibold text-foreground">Africoffee</span>
                  </div>
                  <p className="text-sm text-muted-foreground">
                    {language === 'en' ?'Connecting African coffee excellence with Chinese markets through transparency and quality.' :'通过透明度和质量将非洲咖啡卓越品质与中国市场连接起来。'}
                  </p>
                </div>

                <div>
                  <h3 className="text-sm font-heading font-semibold text-foreground mb-4">
                    {language === 'en' ? 'Quick Links' : '快速链接'}
                  </h3>
                  <ul className="space-y-2 text-sm text-muted-foreground">
                    <li><a href="/browse-beans" className="hover:text-primary transition-smooth">{language === 'en' ? 'Browse Beans' : '浏览咖啡豆'}</a></li>
                    <li><a href="/suppliers" className="hover:text-primary transition-smooth">{language === 'en' ? 'Suppliers' : '供应商'}</a></li>
                    <li><a href="/interactive-farm-map" className="hover:text-primary transition-smooth">{language === 'en' ? 'Farm Map' : '农场地图'}</a></li>
                    <li><a href="/about-us" className="hover:text-primary transition-smooth">{language === 'en' ? 'About Us' : '关于我们'}</a></li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-sm font-heading font-semibold text-foreground mb-4">
                    {language === 'en' ? 'Contact' : '联系方式'}
                  </h3>
                  <ul className="space-y-2 text-sm text-muted-foreground">
                    <li className="flex items-center gap-2">
                      <Icon name="Mail" size={16} />
                      <span>info@africcoffee.com</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <Icon name="Phone" size={16} />
                      <span>+8619706820472</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <Icon name="MapPin" size={16} />
                      <span>{language === 'en' ? 'Deqing County, China' : '中国德清县'}</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="pt-8 border-t border-border text-center text-sm text-muted-foreground">
                <p>&copy; {new Date()?.getFullYear()} Africoffee. {language === 'en' ? 'All rights reserved.' : '版权所有。'}</p>
              </div>
            </div>
          </FullWidthSection>
        </footer>
      </main>
    </div>
  );
};

export default Home;